import React from 'react';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { replace } from 'redux-little-router';
import config from './config';
import './initStore';
import { getStore } from 'configureStore';
import AppContainer from './modules/App/containers/AppContainer';
import { routeMap } from 'router';
import './bootstrap-config.scss';
import './styles/index.scss';
import { remotePaths } from 'router/routes';
import { YMaps } from 'react-yandex-maps';
import REACT_CONFIG from 'REACT_CONFIG';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import queryClient from './constants/queryClient';

const isDev = process.env.NODE_ENV === 'development';

setTimeout(() => {
  isDev &&
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
}, 0);

require('smartbanner.js/dist/smartbanner');
require('smartbanner.js/dist/smartbanner.css');

window.addEventListener('storage', function (e) {
  if (e.key !== config.tokenItemName) {
    return;
  }

  if (e.newValue === null) {
    if (config.isDemoMode) {
      window.location = REACT_CONFIG.REACT_APP_PRIMARY_PATH;
    }
    if (config.isInspectorArm) {
      window.location = remotePaths.taxpayerSearching;
    }
    getStore().dispatch(replace(routeMap.login));
  }
});

window.addEventListener('load', function () {
  // yandex metrika
  if (!isDev) {
    try {
      // eslint-disable-next-line no-undef
      window['yaCounter' + window.yaCounterId] = new Ya.Metrika({
        id: window.yaCounterId,
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
      });

      if (window.additionalYaCounterId) {
        // eslint-disable-next-line no-undef
        window['yaCounter' + window.additionalYaCounterId] = new Ya.Metrika({
          id: window.additionalYaCounterId,
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
        });
      }
    } catch (e) {
      window.console.error(e);
    }
  }
});
const MOUNT_NODE = document.getElementById('app');

const render = (Component) => {
  const MainComponent = (
    <QueryClientProvider client={queryClient}>
      <Provider store={getStore()}>
        <YMaps query={{ lang: 'ru_RU', apikey: config.mapsApiKey, mode: 'debug' }}>
          <Component />
        </YMaps>
      </Provider>

      {isDev ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>
  );
  ReactDOM.render(MainComponent, MOUNT_NODE);
};

render(AppContainer);
